import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const CarotidArtery = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
      <Autocomplete
        value={moduleValues?.['Carotid Artery'] ?? []}
        options={[
            "Carotid Pulse Present",
            "Carotid Pulse Absent",
            "Carotid Pulse Regular",
            "Carotid Pulse Irregular",
            "Carotid Bruits Present",
            "No Carotid Bruits",
            "Other (Specify)",
        ]}
        multiple
        freeSolo
        onChange={(e, value) => setModuleValues(prev => ({...prev, ['Carotid Artery']: value}))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Carotid Artery"
          />
        )}
      />
    </Grid>

)

export default CarotidArtery
